/* Ported from _deploy_baseline/_v3/shell.js by _th-v3-tools/port_assets.py. Edit the source there, then re-run the port. */
/* THUNDER HONEY v3 shell behaviour: header dropdowns (hover, click, keyboard), mobile menu, footer scroll drift and pointer light.
   Scroll state (html.scrolled after 10px) comes from v3.js; it is mirrored here so the shell also works on its own. */
(function () {
  var d = document, w = window, html = d.documentElement;
  var hdr = d.getElementById('th-hdr');
  var reduce = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var mqDesk = w.matchMedia ? w.matchMedia('(min-width: 901px)') : { matches: true };

  function onScroll() { html.classList.toggle('scrolled', w.scrollY > 10); }
  onScroll(); w.addEventListener('scroll', onScroll, { passive: true });

  if (hdr) {
    /* ---------- desktop dropdowns ---------- */
    var items = [].slice.call(hdr.querySelectorAll('[data-th-dd]'));
    var syncHdr = function () { hdr.classList.toggle('has-open', items.some(function (i) { return i.classList.contains('is-open'); })); };
    var setOpen = function (item, open) {
      clearTimeout(item.__t);
      if (item.classList.contains('is-open') === open) return;
      item.classList.toggle('is-open', open);
      item.querySelector('.th-top').setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) item.__at = Date.now(); else item.__kbd = false;
      syncHdr();
    };
    var closeAll = function (except) { items.forEach(function (i) { if (i !== except) setOpen(i, false); }); };

    items.forEach(function (item) {
      var btn = item.querySelector('.th-top');
      var links = function () { return [].slice.call(item.querySelectorAll('.th-dd a')); };

      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !mqDesk.matches) return;
        closeAll(item); setOpen(item, true);
      });
      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse' || item.__kbd) return;
        item.__t = setTimeout(function () { setOpen(item, false); }, 200);
      });
      btn.addEventListener('click', function (e) {
        var open = item.classList.contains('is-open');
        var keyboard = e.detail === 0;
        /* a mouse that just opened it by hovering should not close it again with the same gesture */
        if (open && !keyboard && Date.now() - (item.__at || 0) < 450) return;
        closeAll(item);
        setOpen(item, !open);
        if (!open) item.__kbd = keyboard || e.pointerType === 'touch';
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); closeAll(item); setOpen(item, true); item.__kbd = true;
          var l = links(); if (l[0]) setTimeout(function () { l[0].focus(); }, 30);
        }
      });
      item.querySelector('.th-dd').addEventListener('keydown', function (e) {
        var l = links(), i = l.indexOf(d.activeElement);
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var n = e.key === 'ArrowDown' ? (i + 1) % l.length : (i - 1 + l.length) % l.length;
          l[n].focus();
        } else if (e.key === 'Home') { e.preventDefault(); l[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); l[l.length - 1].focus(); }
      });
      /* tabbing out of a panel closes it */
      item.addEventListener('focusout', function (e) {
        var to = e.relatedTarget;
        if (to ? !item.contains(to) : !item.matches(':hover')) setOpen(item, false);
      });
    });

    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (i) {
        if (!i.classList.contains('is-open')) return;
        var had = i.contains(d.activeElement);
        setOpen(i, false);
        if (had) i.querySelector('.th-top').focus();
      });
    });
    d.addEventListener('pointerdown', function (e) {
      if (!items.some(function (i) { return i.contains(e.target); })) closeAll();
    });

    /* ---------- mobile menu ---------- */
    var burger = hdr.querySelector('.th-burger'), mnav = d.getElementById('th-mnav');
    if (burger && mnav) {
      var focusables = function () {
        return [burger].concat([].slice.call(hdr.querySelectorAll('.th-brand,.th-cart')), [].slice.call(mnav.querySelectorAll('a[href],button'))).filter(function (el) {
          return el.offsetParent !== null && w.getComputedStyle(el).visibility !== 'hidden';
        });
      };
      var openMenu = function () {
        closeAll();
        html.classList.add('th-menu-open');
        mnav.removeAttribute('inert'); mnav.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true'); burger.setAttribute('aria-label', document.documentElement.lang === 'sv' ? 'Stäng menyn' : 'Close menu');
        var sc = mnav.querySelector('.th-mnav__in'); if (sc) sc.scrollTop = 0;
        var first = mnav.querySelector('.th-mg__top');
        if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) { first.focus(); } }, 60);
      };
      var closeMenu = function (returnFocus) {
        if (!html.classList.contains('th-menu-open')) return;
        html.classList.remove('th-menu-open');
        mnav.setAttribute('inert', ''); mnav.setAttribute('aria-hidden', 'true');
        burger.setAttribute('aria-expanded', 'false'); burger.setAttribute('aria-label', document.documentElement.lang === 'sv' ? 'Öppna menyn' : 'Open menu');
        if (returnFocus) burger.focus();
      };
      burger.addEventListener('click', function () { html.classList.contains('th-menu-open') ? closeMenu(false) : openMenu(); });
      mnav.querySelectorAll('.th-mg__top').forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.parentElement, open = !g.classList.contains('is-open');
          g.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
      mnav.querySelectorAll('a[href]').forEach(function (a) { a.addEventListener('click', function () { closeMenu(false); }); });
      d.addEventListener('keydown', function (e) {
        if (!html.classList.contains('th-menu-open')) return;
        if (e.key === 'Escape') { e.preventDefault(); closeMenu(true); return; }
        if (e.key === 'Tab') {
          /* keep focus inside the open menu and its header bar */
          var f = focusables(), i = f.indexOf(d.activeElement);
          e.preventDefault();
          var n = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i < 0 || i === f.length - 1 ? 0 : i + 1);
          f[n].focus();
        }
      });
      var onBp = function () { if (mqDesk.matches) closeMenu(false); else closeAll(); };
      if (mqDesk.addEventListener) mqDesk.addEventListener('change', onBp); else if (mqDesk.addListener) mqDesk.addListener(onBp);
    }
  }

  /* ---------- footer: wordmark drifts in with the scroll, light follows the pointer ---------- */
  var ft = d.getElementById('th-ft');
  if (ft && !reduce.matches) {
    var ticking = false, near = false;
    var upd = function () {
      ticking = false;
      var r = ft.getBoundingClientRect(), vh = w.innerHeight;
      var p = (vh - r.top) / (vh * 0.8);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      ft.style.setProperty('--ft-p', p.toFixed(3));
    };
    var req = function () { if (near && !ticking) { ticking = true; w.requestAnimationFrame(upd); } };
    if ('IntersectionObserver' in w) {
      new IntersectionObserver(function (es) { near = es[0].isIntersecting; if (near) req(); }, { rootMargin: '200px 0px 200px 0px' }).observe(ft);
    } else { near = true; }
    upd();
    w.addEventListener('scroll', req, { passive: true });
    w.addEventListener('resize', function () { near = true; req(); });

    var field = ft.querySelector('.th-ft__field'), raf = 0, mx = 0, my = 0;
    if (field && w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      ft.addEventListener('pointermove', function (e) {
        var fr = field.getBoundingClientRect(); mx = e.clientX - fr.left; my = e.clientY - fr.top;
        if (!raf) raf = w.requestAnimationFrame(function () { raf = 0; ft.style.setProperty('--gx', mx + 'px'); ft.style.setProperty('--gy', my + 'px'); });
        ft.classList.add('is-lit');
      });
      ft.addEventListener('pointerleave', function () { ft.classList.remove('is-lit'); });
    }
  }
})();

/* Campaign passthrough, every V3 page: the ad click ids and utm tags a visitor lands with (utm_*, dig, fbclid, gclid, gbraid,
   wbraid) are copied onto every link to shop.thunderhoney.co, so the shop and its pixels still see where the visit came from.
   A link that already carries a parameter keeps its own value. Same rule as the inline script on the V1 ad pages. */
(function () {
  var w = window, d = document;
  if (w.__thPass) return; w.__thPass = 1;
  var keep;
  try {
    var src = new URLSearchParams(w.location.search); keep = new URLSearchParams();
    src.forEach(function (v, k) { if (/^(utm_[a-z]+|dig|fbclid|gclid|gbraid|wbraid)$/.test(k)) keep.set(k, v); });
  } catch (e) { return; }
  if (!keep.toString()) return;
  function pass() {
    d.querySelectorAll('a[href*="shop.thunderhoney.co"]').forEach(function (a) {
      try {
        var u = new URL(a.href);
        keep.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
        a.href = u.toString();
      } catch (e) { /* a link the URL parser cannot read stays as it is */ }
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', pass); else pass();
})();
